<!-- @format -->

<ng-container *transloco="let t">
  <fudis-notification variant="info">
    <fudis-body-text>
      {{ t("FEEDBACK.NOTIFICATION.TEXT") }}
      <fudis-button [label]="t('FEEDBACK.NOTIFICATION.GO_TO_FEEDBACK')" (handleClick)="goToFeedback()" />
    </fudis-body-text>
  </fudis-notification>
</ng-container>
